<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    {{ 'PROFILE.TITLE' | translate }}
  </h4>
  <button type="button" class="close btn-close-templates" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="profile-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="main-info-wrapper">
      <div class="row">
        <div class="col-sm-2 text-center">
          <app-image-input
            [form]="form"
            controlName="avatar"
            newControlName="new_avatar"
            placeholder="user"
          ></app-image-input>
        </div>
        <div class="col-sm-10">
          <div class="row">
            <div class="col-sm-2">
              <div class="form-group">
                <label>{{ 'PROFILE.PROFILE_FORM.TITLE' | translate }}</label>
                <app-type-select
                  [readonly]="true"
                  [parentFormGroup]="form"
                  [groupType]="'contact_person_title'"
                  [passFormControlName]="'title_id'"
                ></app-type-select>
              </div>
            </div>

            <div class="col-sm-2">
              <div class="form-group">
                <label>{{ 'PROFILE.PROFILE_FORM.FAKE_FIRST_NAME' | translate }}</label>
                <div class="form-control">{{ form.get('fake_first_name').value }}</div>
                <!--<input type="text" class="form-control" formControlName="fake_first_name" />-->
              </div>
            </div>

            <div class="col-sm-2">
              <div class="form-group">
                <label>{{ 'PROFILE.PROFILE_FORM.FAKE_LAST_NAME' | translate }}</label>
                <div class="form-control">{{ form.get('fake_last_name').value }}</div>
                <!--<input type="text" class="form-control" formControlName="fake_last_name" />-->
              </div>
            </div>

            <div class="col-sm-3">
              <div class="form-group">
                <label>{{ 'PROFILE.PROFILE_FORM.EMAIL' | translate }}</label>
                <div class="form-control">{{ form.get('email').value }}</div>
                <!--<input type="email" autocomplete="new-email" class="form-control" formControlName="email" />-->
              </div>
            </div>

            <div class="col-sm-3">
              <div class="form-group">
                <label>{{ 'PROFILE.PROFILE_FORM.FAKE_EMAIL' | translate }}</label>
                <div class="form-control">{{ form.get('fake_email').value }}</div>
                <!--<input type="text" class="form-control" formControlName="fake_email" />-->
              </div>
            </div>

            <!--<div class="col-sm-5">
              <div class="form-group">
                <label>{{ 'USERS.USERS_FORM.LOCALES' | translate }}</label>
                <app-locales-select [FormControl]="form.get('locales')"></app-locales-select>
              </div>
            </div>-->

            <!--<div class="col-sm-5">
              <div class="form-group">
                <label>{{ 'USERS.USERS_FORM.COMPANIES' | translate }}</label>
                <app-companies-select [FormControl]="form.get('companies')"></app-companies-select>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </form>

  <form id="change-password-form" (ngSubmit)="saveChangePassword()" [formGroup]="formPass" novalidate>
    <div class="row">
      <div class="col-12 mt-4">
        <div class="form-title">{{ 'PROFILE.PROFILE_FORM.CHANGE_PASSWORD' | translate }}</div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'PROFILE.PROFILE_FORM.OLD_PASSWORD' | translate }}</label>
          <input type="password" autocomplete="new-password" class="form-control" formControlName="current_password" />
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'PROFILE.PROFILE_FORM.NEW_PASSWORD' | translate }}</label>
          <input type="password" autocomplete="new-password" class="form-control" formControlName="new_password" />
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label>{{ 'PROFILE.PROFILE_FORM.CONFIRM_NEW_PASSWORD' | translate }}</label>
          <input
            type="password"
            autocomplete="new-password"
            class="form-control"
            formControlName="new_password_confirmation"
          />
          <small class="theme-color-danger" *ngIf="this.formPass.invalid && this.formPass.errors?.notSame">
            {{ 'PROFILE.PROFILE_FORM.PASSWORD_DO_NOT_MATCH' | translate }}
          </small>
        </div>
      </div>

      <div class="col-sm-3">
        <button
          type="submit"
          form="change-password-form"
          [disabled]="formPass.invalid"
          class="btn btn-primary btn-change-pass"
        >
          {{ 'PROFILE.PROFILE_FORM.CHANGE_PASSWORD_SUBMIT_BUTTON' | translate }}
        </button>
      </div>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="profile-form" [disabled]="form.invalid">
    {{ 'SUPPLIERS.SUPPLIERS_FORM.SAVE' | translate }}
  </button>
</div>
